"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIAOMI = [
    { deviceName: 'Xiaomi Mi 1S', brandName: 'Xiaomi', deviceCode: 'MI 1S' },
    { deviceName: 'Xiaomi Mi 1', brandName: 'Xiaomi', deviceCode: 'MI1' },
    { deviceName: 'Xiaomi Mi 2S', brandName: 'Xiaomi', deviceCode: 'MI 2S' },
    { deviceName: 'Xiaomi Mi 2A', brandName: 'Xiaomi', deviceCode: 'MI 2A' },
    { deviceName: 'Xiaomi Mi 2', brandName: 'Xiaomi', deviceCode: 'MI 2' },
    { deviceName: 'Xiaomi Mi 3', brandName: 'Xiaomi', deviceCode: 'MI 3' },
    { deviceName: 'Xiaomi Mi 4s', brandName: 'Xiaomi', deviceCode: 'MI 4S' },
    { deviceName: 'Xiaomi Mi 4', brandName: 'Xiaomi', deviceCode: 'MI 4' },
    { deviceName: 'Xiaomi Mi 4c', brandName: 'Xiaomi', deviceCode: 'M4C' },
    { deviceName: 'Xiaomi Mi 5s Plus', brandName: 'Xiaomi', deviceCode: 'MI 5s Plus' },
    { deviceName: 'Xiaomi Mi 5s', brandName: 'Xiaomi', deviceCode: 'MI 5s' },
    { deviceName: 'Xiaomi Mi 5c', brandName: 'Xiaomi', deviceCode: 'MI 5C' },
    { deviceName: 'Xiaomi Mi 5X', brandName: 'Xiaomi', deviceCode: 'MI 5X' },
    { deviceName: 'Xiaomi Mi 5', brandName: 'Xiaomi', deviceCode: 'MI 5' },
    { deviceName: 'Xiaomi Mi 6X', brandName: 'Xiaomi', deviceCode: 'MI 6X' },
    { deviceName: 'Xiaomi Mi 6', brandName: 'Xiaomi', deviceCode: 'MI 6' },
    { deviceName: 'Xiaomi Mi A2 Lite', brandName: 'Xiaomi', deviceCode: 'Mi A2 Lite' },
    { deviceName: 'Xiaomi Mi A2', brandName: 'Xiaomi', deviceCode: 'Mi A2' },
    { deviceName: 'Xiaomi Mi 8 SE', brandName: 'Xiaomi', deviceCode: 'MI 8 SE' },
    { deviceName: 'Xiaomi Mi 8 Lite', brandName: 'Xiaomi', deviceCode: 'MI 8 Lite' },
    { deviceName: 'Xiaomi Mi 8', brandName: 'Xiaomi', deviceCode: 'MI 8' },
    { deviceName: 'Xiaomi Mi 9 SE', brandName: 'Xiaomi', deviceCode: 'MI 9 SE' },
    { deviceName: 'Xiaomi Mi 9T', brandName: 'Xiaomi', deviceCode: 'Mi 9T' },
    { deviceName: 'Xiaomi Mi 9T Pro', brandName: 'Xiaomi', deviceCode: 'Mi 9T Pro' },
    { deviceName: 'Xiaomi Mi 9 Lite', brandName: 'Xiaomi', deviceCode: 'Mi 9 Lite' },
    { deviceName: 'Xiaomi Mi 9 Pro', brandName: 'Xiaomi', deviceCode: 'Mi 9 Pro' },
    { deviceName: 'Xiaomi Mi 9', brandName: 'Xiaomi', deviceCode: 'MI 9' },
    { deviceName: 'Xiaomi Mi CC 9e', brandName: 'Xiaomi', deviceCode: 'MI CC 9e' },
    { deviceName: 'Xiaomi Mi CC 9', brandName: 'Xiaomi', deviceCode: 'MI CC 9' },
    { deviceName: 'Xiaomi Mi Note Pro', brandName: 'Xiaomi', deviceCode: 'MI NOTE Pro' },
    { deviceName: 'Xiaomi MI Note 2', brandName: 'Xiaomi', deviceCode: 'Mi Note 2' },
    { deviceName: 'Xiaomi Mi Note 3', brandName: 'Xiaomi', deviceCode: 'Mi Note 3' },
    { deviceName: 'Xiaomi Mi Note', brandName: 'Xiaomi', deviceCode: 'MI NOTE' },
    { deviceName: 'Xiaomi Mi Max 2', brandName: 'Xiaomi', deviceCode: 'MI MAX 2' },
    { deviceName: 'Xiaomi Mi Max 3', brandName: 'Xiaomi', deviceCode: 'MI MAX 3' },
    { deviceName: 'Xiaomi Mi Max Prime', brandName: 'Xiaomi', deviceCode: 'Mi Max Prime' },
    { deviceName: 'Xiaomi Mi Max', brandName: 'Xiaomi', deviceCode: 'MI MAX' },
    { deviceName: 'Xiaomi Mi MIX 2S', brandName: 'Xiaomi', deviceCode: 'Mi MIX 2S' },
    { deviceName: 'Xiaomi Mi MIX 2', brandName: 'Xiaomi', deviceCode: 'Mi MIX 2' },
    { deviceName: 'Xiaomi Mi MIX 3', brandName: 'Xiaomi', deviceCode: 'Mi MIX 3' },
    { deviceName: 'Xiaomi Mi MIX', brandName: 'Xiaomi', deviceCode: 'MI MIX' },
    { deviceName: 'Xiaomi Mi Pad 2', brandName: 'Xiaomi', deviceCode: 'MI PAD 2' },
    { deviceName: 'Xiaomi Mi Pad 3', brandName: 'Xiaomi', deviceCode: 'MI PAD 3' },
    { deviceName: 'Xiaomi Mi Pad 4 Plus', brandName: 'Xiaomi', deviceCode: 'MI PAD 4 PLUS' },
    { deviceName: 'Xiaomi Mi Pad 4', brandName: 'Xiaomi', deviceCode: 'MI PAD 4' },
    { deviceName: 'Xiaomi Mi Pad', brandName: 'Xiaomi', deviceCode: 'MI PAD' },
    { deviceName: 'Xiaomi Redmi 1S', brandName: 'Xiaomi', deviceCode: 'HM 1S' },
    { deviceName: 'Xiaomi Redmi 3S', brandName: 'Xiaomi', deviceCode: 'Redmi 3S' },
    { deviceName: 'Xiaomi Redmi 3X', brandName: 'Xiaomi', deviceCode: 'Redmi 3X' },
    { deviceName: 'Xiaomi Redmi 3', brandName: 'Xiaomi', deviceCode: 'Redmi 3' },
    { deviceName: 'Xiaomi Redmi Pro', brandName: 'Xiaomi', deviceCode: 'Redmi Pro' },
    { deviceName: 'Xiaomi Redmi 4A', brandName: 'Xiaomi', deviceCode: 'Redmi 4A' },
    { deviceName: 'Xiaomi Redmi 4X', brandName: 'Xiaomi', deviceCode: 'Redmi 4X' },
    { deviceName: 'Xiaomi Redmi 4 Prime', brandName: 'Xiaomi', deviceCode: 'Redmi 4 Prime' },
    { deviceName: 'Xiaomi Redmi 4 Pro', brandName: 'Xiaomi', deviceCode: 'Redmi 4 Pro' },
    { deviceName: 'Xiaomi Redmi 4', brandName: 'Xiaomi', deviceCode: 'Redmi 4' },
    { deviceName: 'Xiaomi Redmi 5 Plus', brandName: 'Xiaomi', deviceCode: 'Redmi 5 Plus' },
    { deviceName: 'Xiaomi Redmi 5A', brandName: 'Xiaomi', deviceCode: 'Redmi 5A' },
    { deviceName: 'Xiaomi Redmi 5', brandName: 'Xiaomi', deviceCode: 'Redmi 5' },
    { deviceName: 'Xiaomi Redmi 6A', brandName: 'Xiaomi', deviceCode: 'Redmi 6A' },
    { deviceName: 'Xiaomi Redmi 6 Pro', brandName: 'Xiaomi', deviceCode: 'Redmi 6 Pro' },
    { deviceName: 'Xiaomi Redmi 6', brandName: 'Xiaomi', deviceCode: 'Redmi 6' },
    { deviceName: 'Xiaomi Redmi Go', brandName: 'Xiaomi', deviceCode: 'Redmi Go' },
    { deviceName: 'Xiaomi Redmi 7A', brandName: 'Xiaomi', deviceCode: 'Redmi 7A' },
    { deviceName: 'Xiaomi Redmi 7', brandName: 'Xiaomi', deviceCode: 'Redmi 7' },
    { deviceName: 'Xiaomi Redmi Y1 Lite', brandName: 'Xiaomi', deviceCode: 'Redmi Y1 Lite' },
    { deviceName: 'Xiaomi Redmi Y1', brandName: 'Xiaomi', deviceCode: 'Redmi Y1' },
    { deviceName: 'Xiaomi Redmi Y2', brandName: 'Xiaomi', deviceCode: 'Redmi Y2' },
    { deviceName: 'Xiaomi Redmi Y3', brandName: 'Xiaomi', deviceCode: 'Redmi Y3' },
    { deviceName: 'Xiaomi Redmi 8A', brandName: 'Xiaomi', deviceCode: 'Redmi Redmi 8A' },
    { deviceName: 'Xiaomi Redmi 8', brandName: 'Xiaomi', deviceCode: 'Redmi Redmi 8' },
    {
        deviceName: 'Xiaomi Redmi K20 Pro Premium Edition',
        brandName: 'Xiaomi',
        deviceCode: 'Redmi K20 Pro Premium Edition'
    },
    { deviceName: 'Xiaomi Redmi K20 Pro', brandName: 'Xiaomi', deviceCode: 'Redmi K20 Pro' },
    { deviceName: 'Xiaomi Redmi K20', brandName: 'Xiaomi', deviceCode: 'Redmi K20' },
    { deviceName: 'Xiaomi Redmi Note 2', brandName: 'Xiaomi', deviceCode: 'Redmi Note 2' },
    { deviceName: 'Xiaomi Redmi Note 3', brandName: 'Xiaomi', deviceCode: 'Redmi Note 3' },
    { deviceName: 'Xiaomi Redmi Note 4X', brandName: 'Xiaomi', deviceCode: 'Redmi Note 4X' },
    { deviceName: 'Xiaomi Redmi Note 4', brandName: 'Xiaomi', deviceCode: 'Redmi Note 4' },
    { deviceName: 'Xiaomi Redmi Note 5 Pro', brandName: 'Xiaomi', deviceCode: 'Redmi Note 5 Pro' },
    {
        deviceName: 'Xiaomi Redmi Note 5A Prime',
        brandName: 'Xiaomi',
        deviceCode: 'Redmi Note 5A Prime'
    },
    { deviceName: 'Xiaomi Redmi Note 5A', brandName: 'Xiaomi', deviceCode: 'Redmi Note 5A' },
    { deviceName: 'Xiaomi Redmi Note 5', brandName: 'Xiaomi', deviceCode: 'Redmi Note 5' },
    { deviceName: 'Xiaomi Redmi Note 6 Pro', brandName: 'Xiaomi', deviceCode: 'Redmi Note 6 Pro' },
    { deviceName: 'Xiaomi Redmi Note 7 Pro', brandName: 'Xiaomi', deviceCode: 'Redmi Note 7 Pro' },
    { deviceName: 'Xiaomi Redmi Note 7S', brandName: 'Xiaomi', deviceCode: 'Redmi Note 7S' },
    { deviceName: 'Xiaomi Redmi Note 7', brandName: 'Xiaomi', deviceCode: 'Redmi Note 7' },
    { deviceName: 'Xiaomi Redmi Note 8 Pro', brandName: 'Xiaomi', deviceCode: 'Redmi Note 8 Pro' },
    { deviceName: 'Xiaomi Redmi Note 8', brandName: 'Xiaomi', deviceCode: 'Redmi Note 8' },
    { deviceName: 'Xiaomi Redmi K30 5G', brandName: 'Xiaomi', deviceCode: 'Redmi K30 5G' }
];
//# sourceMappingURL=xiaomi.js.map